import { __decorate } from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import Base from './Base';
import { FormField } from '../field/FormField';
let Paragraph = class Paragraph extends FormField {
    renderWrapper() {
        return (React.createElement(React.Fragment, null,
            React.createElement(Base, Object.assign({}, this.props, { component: "div" }), this.processRenderer(this.getValue()) || this.props.children),
            this.renderFloatLabel()));
    }
};
Paragraph.displayName = 'Paragraph';
Paragraph.__PRO_TEXT = true;
Paragraph.defaultProps = {
    ...FormField.defaultProps,
    suffixCls: 'paragraph',
};
Paragraph = __decorate([
    observer
], Paragraph);
export default Paragraph;
